import type { FC, ComponentType } from 'react';
import React from 'react';

import type { EditorActions } from '@atlaskit/editor-core/actions';
import { WithEditorActions } from '@atlaskit/editor-core/WithEditorActions';
import { EditorContext } from '@atlaskit/editor-core/EditorContext';

type WithEditorActionsProps = {
	editorActions: EditorActions;
};

export function withEditorActions<T>(
	WrappedComponent: ComponentType<T>,
): FC<Omit<T, keyof WithEditorActionsProps>> {
	function withEditorActions(props) {
		return (
			<EditorContext>
				<WithEditorActions
					render={(editorActions: EditorActions) => (
						<WrappedComponent editorActions={editorActions} {...props} />
					)}
				/>
			</EditorContext>
		);
	}
	return withEditorActions;
}
